<template>
    <div class="page padding-bottom-50 padding-top-50">
        <div class="item" v-for="item in items" :key="item.id">
            <or-product-text v-if="item.component === 'text'" :options="item"/>
            <or-product-image v-if="item.component === 'image'" :options="item"/>
            <or-product-table v-if="item.component === 'table'" :options="item"/>
        </div>
        <p class="close padding-top-50 hover-pointer hover-yellow nasting-main" @click="$emit('close')">Вернуться к списку изделий</p>
    </div>
</template>

<script>
import orProductText from "./or-product-text.vue"
import orProductImage from "./or-product-image.vue"
import orProductTable from "./or-product-table.vue"
export default {
    components: {
        orProductText,
        orProductImage,
        orProductTable
    },
    props: {
        items: Array,
        scroll_top: Number,
    },
    mounted() {
        window.scrollTo(0,0);
    },
    unmounted() {
        window.scrollTo(0, this.scroll_top);
    },
}   
</script>

<style scoped>
  * {
    color: white;
  }
  .page {
    background-color: #1f1f1f;
    border-radius: 8px;
  }
  .close {
    font-size: 14px;
    line-height: 16px;
    color: white;
  }
</style>